"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _withWrapper = _interopRequireDefault(require("../withWrapper"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _withWrapper.default)('SwitchOff', function (props) {
  return _react.default.createElement("svg", {
    width: "12",
    height: "12",
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.28033 3.21967C3.98744 2.92678 3.51256 2.92678 3.21967 3.21967C2.92678 3.51256 2.92678 3.98744 3.21967 4.28033L4.9415 6.00216L3.21974 7.72393C2.92685 8.01682 2.92685 8.4917 3.21974 8.78459C3.51263 9.07748 3.98751 9.07748 4.2804 8.78459L6.00216 7.06282L7.72393 8.78459C8.01682 9.07748 8.4917 9.07748 8.78459 8.78459C9.07748 8.4917 9.07748 8.01682 8.78459 7.72393L7.06282 6.00216L8.78466 4.28033C9.07755 3.98744 9.07755 3.51256 8.78466 3.21967C8.49177 2.92678 8.01689 2.92678 7.724 3.21967L6.00216 4.9415L4.28033 3.21967Z",
    fill: "#DFE0E2"
  }));
});

exports.default = _default;